import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_10: FaireProductEntity = {
  token: "casa-bosques-10",
  type: "product",
  name: "Dream Lion Incense",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b3503ac0d6e409146515fd732ade635576645ea9ce25f9e3162a5e8b7af7f2fb.webp",
  priceDollars: 18,
  msrpDollars: 28,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
